import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createBranchApi,
  getBranchApi,
  updateBranchApi,
  uploadBranchApi,
} from "./branchApi";

export const getBranchRequest = createAsyncThunk(
  "getBranchRequest/branch",
  async () => {
    try {
      const response = await getBranchApi();
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const createBranchRequest = createAsyncThunk(
  "createBranchRequest/branch",
  async (payload: any) => {
    console.log("PA", payload);

    try {
      const response = await createBranchApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const updateBranchRequest = createAsyncThunk(
  "updateBranchRequest/branch",
  async (payload: any) => {
    console.log("PA", payload);

    try {
      const response = await updateBranchApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const uploadBranchRequest = createAsyncThunk(
  "uploadBranchRequest/branch",
  async (payload: any) => {
    console.log("PA", payload);

    try {
      const response = await uploadBranchApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  branchList: any[];
  message: string;
  pageIsLoading: boolean;
  isSuccess: boolean;
  createBranch: any;
  updateBranch: any;
  uploadBranch: any;
}

const initialState: IInitialState = {
  branchList: [],
  message: "",
  pageIsLoading: false,
  isSuccess: false,
  createBranch: {},
  updateBranch: {},
  uploadBranch: null,
};

const branchSlice = createSlice({
  name: "branch",
  initialState: initialState,
  reducers: {
    resetBranchMessage: (state) => {
      state.message = "";
    },
    resetBranchSuccess: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // get branch reducer
    builder.addCase(getBranchRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getBranchRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.branchList = action.payload.data;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getBranchRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // createBranch
    builder.addCase(createBranchRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(createBranchRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.createBranch = action.payload.data;
        state.pageIsLoading = false;
        state.isSuccess = true;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(createBranchRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // updateBranch
    builder.addCase(updateBranchRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateBranchRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.updateBranch = action.payload.data;
        state.pageIsLoading = false;
        state.isSuccess = true;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateBranchRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });

    // uploadBranch
    builder.addCase(uploadBranchRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(uploadBranchRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.uploadBranch = action.payload.data;
        state.pageIsLoading = false;
        state.isSuccess = true;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(uploadBranchRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetBranchMessage, resetBranchSuccess } = branchSlice.actions;
export default branchSlice.reducer;
